// Returns an experience's description as a list of bullet strings for the given
// language. Prefers the explicit `bullets` list; otherwise splits the legacy
// `description_es/en` text into sentences so old data still renders as a list.
export function experienceBullets(e, language) {
  if (Array.isArray(e.bullets) && e.bullets.length) {
    return e.bullets
      .map((b) => (language === "es" ? b.es : b.en))
      .map((s) => (s || "").trim())
      .filter(Boolean);
  }
  const desc = (language === "es" ? e.description_es : e.description_en) || "";
  return desc
    .split(/\.\s+/)
    .map((s) => s.trim().replace(/\.+$/, ""))
    .filter(Boolean);
}
